import React, { useEffect, useState } from "react";

function computeParts(targetIso) {
  const target = new Date(targetIso).getTime();
  const now = Date.now();
  let diff = Math.max(0, target - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  diff -= days * (1000 * 60 * 60 * 24);
  const hours = Math.floor(diff / (1000 * 60 * 60));
  diff -= hours * (1000 * 60 * 60);
  const minutes = Math.floor(diff / (1000 * 60));
  diff -= minutes * (1000 * 60);
  const seconds = Math.floor(diff / 1000);
  return { days, hours, minutes, seconds };
}

export default function Countdown({ targetIso }) {
  const [parts, setParts] = useState(() => computeParts(targetIso));

  useEffect(() => {
    const id = setInterval(() => setParts(computeParts(targetIso)), 1000);
    return () => clearInterval(id);
  }, [targetIso]);

  const items = [
    { label: "Jours", value: parts.days },
    { label: "Heures", value: parts.hours },
    { label: "Minutes", value: parts.minutes },
    { label: "Secondes", value: parts.seconds },
  ];

  return (
    <div className="grid grid-cols-4 gap-6 md:gap-16" data-testid="countdown">
      {items.map((it) => (
        <div key={it.label} className="flex flex-col">
          <span
            className="font-serif"
            style={{ color: "#F8F6F0", fontSize: "clamp(48px, 8vw, 96px)", lineHeight: 1 }}
            data-testid={`countdown-${it.label.toLowerCase()}`}
          >
            {String(it.value).padStart(2, "0")}
          </span>
          <span className="label mt-4">{it.label}</span>
        </div>
      ))}
    </div>
  );
}
